import { useEffect, useState } from "react";
import { getIsOpcoOwner } from "../api/opcoProjectsHttpClient";

export const useIsOpcoOwner = () => {
  const [isOpcoOwner, setIsOpcoOwner] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchIsOpcoOwner = async () => {
      try {
        const result = await getIsOpcoOwner();
        setIsOpcoOwner(result);
      } catch {
        setIsOpcoOwner(false);
      } finally {
        setIsLoading(false);
      }
    };

    fetchIsOpcoOwner();
  }, []);

  return { isOpcoOwner, isLoading };
};
